import ReactLoadingSkeleton from 'react-loading-skeleton';

import type { SkeletonProps } from '../Skeleton.types';

export const GraphSkeleton = ({ ...props }: SkeletonProps) => {
  const barHeights = [102, 128, 82, 72, 102, 128, 82, 116, 102, 128, 82, 116];
  const graphClasses = 'flex flex-row justify-center items-end mt-[161px] ml-8 border-b border-neutral-300';

  return (
    <div className="flex flex-col justify-between" data-testid="skeleton-graph" {...props}>
      <ReactLoadingSkeleton borderRadius={1} height={16} width={120} />

      <div className={graphClasses}>
        {barHeights.map((height, i) => (
          // oxlint-disable-next-line react/no-array-index-key -- Ok as don't expect the array to change
          <span className="mr-3" key={i}>
            <ReactLoadingSkeleton borderRadius={1} height={height} width={20} />
          </span>
        ))}
      </div>
    </div>
  );
};
